<template>
  <article v-if="loaded" class="section section--full-width">
    <actionModal
      v-if="actionModal.show"
      :active="actionModal.show"
      :css="actionModal.css"
      :body="actionModal.body"
      :size="actionModal.size"
      :btn="actionModal.btn"
      :action="actionModal.action"
      @close="actionModal.show = false"
    />

    <header class="section__header">
      <h2 class="section__title">
        <router-link :to="{ name: 'DoctorUsersOfficeList' }">
          Usuários
        </router-link>
      </h2>
    </header>

    <section class="section__wrapper section__wrapper--no-border">
      <p id="TOUR_USERS_P">
        Nessa seção você poderá incluir novos usuários que utilizarão
        a nossa plataforma para auxiliar na gestão do consultório, como
        recepcionistas e financeiro. Os tipos de acesso terão visão
        limitada aos dados de acordo com cada perfil.
      </p>

      <transition name="fade" mode="out-in">
        <router-view
          v-if="loaded && !fetching"
          id="TOUR_USERS_VIEW"
          :users.sync="users"
          @update="fetchUsers()"
        />

        <dr-loader
          v-if="loaded && fetching"
          size="lg"
          class="loader flex-center"
        />
      </transition>

      <span id="TOUR_USERS_BTN" style="visibility: hidden; outline: 0 !important"></span>
    </section>
  </article>
</template>

<script>
import actionModal from '@/components/modals/action'
import { mapGetters } from 'vuex'

export default {
  name: 'DrUsersOffice',

  components: {
    actionModal
  },

  data () {
    return {
      loaded: false,
      fetching: false,
      users: [],
      actionModal: {
        show: false,
        size: 'md3',
        css: `
          color: white !important;
          background: url(/static/img/modal_cadastro.png);
          background-size: cover;
          background-position: right center
          `,
        btn: {
          class: 'btn-navy ',
          text: 'Cadastrar consultório'
        },
        body: `
          <div class="col-6"><h2 style="color: white">Cadastre seu consultório!</h2>
          <p>Para usufruir de todas as funcionalidades que o Dr. Conecta oferece, cadastre seu consultório. É rápido e fácil!</p>
          </div>`,
        action: function () {
          this.$router.push('/doctor/user/offices')
          this.close()
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    })
  },

  watch: {
    '$route.name': function (next, prev) {
      this.fn_HIDE_PROGRESS()
    }
  },

  mounted () {
    this.fetchUsers()
  },

  methods: {
    fetchUsers () {
      const url = `/doctor/doctor_office/${this.office.id}/user?filterAndLike[u.roles]=ROLE_SECRETARY`

      this.fetching = true
      this.fn_SHOW_PROGRESS()

      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          this.fetching = false
          this.users = res.data.data
        })
        .catch((err) => console.log(err))
        .finally(() => {
          this.loaded = true
          this.fn_HIDE_PROGRESS()
        })
    }
  }
}
</script>
